var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnbounce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_1094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 15C146.974 15 185 53.0263 185 100C185 146.974 146.974 185 100 185C53.0263 185 15 146.974 15 100C15 53.0263 53.0263 15 100 15ZM119.812 43.1203C116.297 42.0019 112.462 43.4398 110.545 46.4756C107.19 45.8365 103.835 45.5169 100.32 45.5169C70.1222 45.5169 45.8365 69.9624 45.8365 100C45.8365 121.09 57.8195 139.464 75.3947 148.412C74.9154 151.927 77.1523 155.442 80.6673 156.72C81.4662 157.039 82.4248 157.199 83.2237 157.199C84.5019 157.199 85.7801 156.88 86.8985 156.241C88.1767 155.602 89.1353 154.643 89.9342 153.365C90.2538 152.885 90.5733 152.406 90.7331 151.767L96.9643 133.393L118.694 71.5602L124.925 53.1861C125.085 52.7068 125.244 52.0677 125.244 51.4286C125.404 49.6711 124.925 48.0733 124.126 46.6353C123.167 45.0376 121.729 43.7594 119.812 43.1203ZM135.31 58.6184L127.801 81.3064C131.476 86.5789 133.553 93.1297 133.553 100C133.553 114.699 124.286 127.002 111.344 131.635L103.835 154.323C132.115 152.246 154.323 128.759 154.483 100C154.483 83.3835 146.974 68.5244 135.31 58.6184ZM100 66.4474C100.959 66.4474 102.077 66.4474 103.036 66.6071L81.9455 128.28C72.6786 122.209 66.4474 111.823 66.4474 100C66.4474 81.4662 81.4662 66.4474 100 66.4474Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_1094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbounce);
export default __webpack_public_path__ + "static/media/Unbounce.a60f09f382e5b3dc9f4f456bfab0681a.svg";
export { ForwardRef as ReactComponent };